import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const OrderLeftColorCode = styled.div`
    border-left: 5px solid;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: ${(props) => props.backgroundColor};
    border-color: ${(props) => props.borderColor};
`;

export const ContentConatiner = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 15px 22px 10px 22px;
    font-family: AvenirNextWorld Regular;
    color: #4f4f4f;
    width: 100%;
`;

export const ContentHeaderFooter = styled.div`
    margin: 0;
    padding: 0;
    font-size: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: ${({ width }) => (width ? width : '')};
    @media only screen and (max-device-width: 360px) {
        flex-direction: ${({ isContentHeaderFooter }) =>
            isContentHeaderFooter && 'column'};
    };
    ${media.mobileDevice`
        flex-wrap: wrap;
    `}
`;

export const ContentBody = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin: ${({ margin }) => (margin ? margin : 0)};
`;

export const NormalDiv = styled.div`
    height: ${(props) => props.height};
    display:${(props) => props?.display? props.display : 'flex'};
    align-items: center;
    padding: 0;
    margin: ${({ margin }) => (margin ? margin : 0)};

    @media only screen and (max-device-width: 360px) {
        width: ${({ isContentHeaderFooter }) =>
            isContentHeaderFooter && '100%'};
    }
`;

export const DemiText = styled.div`
    color: ${(props) => (props.color ? props.color : '#585858')};
    font-size: ${(props) => props.fontSize};
    opacity: ${(props) => (props.opacity ? props.opacity : 1)};
    font-family: AvenirNextWorld Demi;
    margin: ${({ margin }) => (margin ? margin : 0)};
    flex-shrink: ${({ flexShrink }) => (flexShrink ? flexShrink : '')};
    line-height: ${({ lineHeight }) => lineHeight};
    border: ${({ border }) => border};
    border-radius: ${({ borderRadius }) => borderRadius};
    padding: ${({ padding }) => padding};

    @media only screen and (max-device-width: 360px) {
        font-size: ${({ fontSize }) => (fontSize ? fontSize : '12px')};
    }
`;

export const RegularText = styled.div`
    color: ${(props) => (props.color ? props.color : '#585858')};
    font-size: ${(props) => props.fontSize};
    opacity: ${(props) => (props.opacity ? props.opacity : 1)};
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Regular'};
    margin: ${({ margin }) => (margin ? margin : 0)};
    line-height: ${({ lineHeight }) => lineHeight};
`;

export const RegularTrucateText = styled.p`
    margin: 0 2px 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    // white-space: nowrap;
    width: ${({ width }) => (width ? width : '60%')};
    color: ${(props) => (props.color ? props.color : '#585858')};
    font-size: ${(props) => props.fontSize};
    display: ${(props) => props.display};
    align-items: ${(props) => props.alignItems};
    opacity: ${(props) => (props.opacity ? props.opacity : 1)};
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Regular'};
`;

export const StyledFlag = styled.div`
    position: absolute;
    right: 0;
`;

export const MycaseAndPrice = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const Prices = styled.div`
    margin : ${(props) => props.marginFlag};
    display: flex;
    flex-direction: row;
    align-items: center;
`;
